import * as React from 'react'
import cx from 'classnames'
import styles from './ButtonCollection.sass'

interface Props {
  children?: React.ReactNode
  centered?: boolean
  fullWidth?: boolean
}

export default function ButtonCollection({
  children,
  centered,
  fullWidth = false,
}: Props) {
  return (
    <div
      className={cx(
        styles.root,
        centered && styles.centered,
        fullWidth && styles.fullWidth,
      )}
    >
      {React.Children.map(
        children,
        (child) =>
          child && (
            <div className={cx(styles.item, fullWidth && styles.fullWidth)}>
              {child}
            </div>
          ),
      )}
    </div>
  )
}
